import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BreakpointObserverService } from '../../shared/services/breakpoint-observer.service';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { filter } from 'rxjs';
import { HwwHelpService, SchemaButton } from './hww-info/hww-help.service';
import { UserAccessService } from '../../user/access/user-access.service';
import { SubscriptionPlans } from '../../user/user/user.model';
import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { TopNavComponent } from '../../shared/components/top-nav/top-nav.component';
import { SiteFooterComponent } from '../../shared/components/site-footer/site-footer.component';
import { SALES_FORECAST_BASE_PATH } from '../../sales-forecast/sales-forecast.routes-data';

@Component({
  selector: 'app-data-info',
  templateUrl: './data-info.component.html',
  styleUrls: ['./data-info.component.scss'],
  imports: [
    RouterOutlet,
    NgIf,
    RouterLink,
    RouterLinkActive,
    NgClass,
    AsyncPipe,
    TopNavComponent,
    SiteFooterComponent,
  ],
})
export class DataInfoComponent implements OnInit {
  public readonly HWW_PATH = 'healthy-wealthy-and-wise';
  public readonly DATA_SOURCES_PATH = 'data-sources';

  public currentPath = '';

  private destroyRef = inject(DestroyRef);

  constructor(
    public breakpointObserverService: BreakpointObserverService,
    private router: Router,
    private hwwService: HwwHelpService,
    public accessService: UserAccessService
  ) {}

  ngOnInit() {
    this.currentPath = this.router.url;

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((event: any) => {
        this.currentPath = event.urlAfterRedirects;
      });
  }

  public handleHwwButtonClick(): void {
    this.hwwService.activeButton.next(SchemaButton.PRIMARY);
  }

  // This page is one of the trust links the site-selection funnel's
  // top-nav "Company" menu points to (see TopNavComponent), so an
  // already-subscribed visitor landing here has no report/address context
  // to scroll to — send them back into that tool to actually order one,
  // instead of the CTA doing nothing.
  public onTopNavOrderReport(): void {
    this.router.navigate([`/${SALES_FORECAST_BASE_PATH}`]);
  }

  protected readonly SubscriptionPlans = SubscriptionPlans;
}
